(function(){

  'use strict';

    // **********************************
    //  Data that this directive needs
    // ----------------------------------
    // 
    //

  function pxPrintQueueAutoInstall(
    toastr, $filter
    ) {
    return {
      restrict: 'EA',
      scope: {
        context: '=context',
        meta: '=meta',
        callback: '&callback'
      },
      templateUrl: 'app/components/printQueueProperties/printQueueGroups/autoInstall/printQueueAutoInstall.template.html',
      link: function(scope) {

        scope.saveAutoInstallSetting = function () {
          var settingChange = [{
              op: 'replace',
              path: '/autoInstall',
              value: scope.context.autoInstall
            }]
          scope.context.changeSetting(settingChange).then(function(response) {
            toastr.success($filter("translate")("ChangesSaved"))
            scope.callback();
          }).catch(function(error) {
            toastr.error($filter("translate")("ERROR"))
            scope.callback();
          });
        }

      }
    };
  }

  pxPrintQueueAutoInstall.$inject = ['toastr', '$filter'];

  angular
    .module('printix-admin')
    .directive('pxPrintQueueAutoInstall', pxPrintQueueAutoInstall);

})();
